module.exports = __webpack_public_path__ + "static/media/wide.e1bebc94.jpg";